module.exports = __webpack_public_path__ + "static/media/a11y.9491ce03.png";